import styled from 'styled-components'

export const CustomProductForm = styled.div`
  font-size: 1rem;
  display: grid;
  gap: 0.63em;
	margin-bottom: 0.63em;
`
CustomProductForm.displayName = 'CustomProductForm'
